import styled from "styled-components";

export const ServicesList = styled.ul<{ $compact?: boolean }>(
  ({ theme, $compact }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    listStyle: "none",
    margin: 0,
    padding: 0,
    li: {
      display: "flex",
      alignItems: "flex-start",
      gap: "4px",
      color: theme.kallisto.color.text.static.textSecondary,
      svg: {
        flexShrink: 0,
      },
    },
    "[data-testid='weg-de-voucher'], [data-testid^='weg-perk-']": {
      color: theme.kallisto.color.text.static.textSuccess,
      ".weg-de-voucher-dialog-tooltip, .weg-perk-dialog-tooltip": {
        marginLeft: $compact ? undefined : "auto",
        alignSelf: $compact ? "center" : undefined,
        svg: {
          cursor: "pointer",
          "&:hover": {
            color: theme.kallisto.color.text.interactive.textPrimaryDefault,
          },
        },
      },
    },
  })
);

export const DialogTooltipContent = styled.div(({ theme }) => ({
  p: {
    marginBottom: "1rem",
  },
  a: {
    textDecoration: "none",
    span: {
      color: theme.kallisto.color.text.interactive.textPrimaryDefault,
    },
  },
}));

export const RoomLabelsContainer = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  span: {
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical" as const,
    overflow: "hidden",
  },
}));

export const RailAndFlyContainer = styled.div<{ $compact?: boolean }>(
  ({ theme, $compact }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: "4px",
    width: "100%",
    color: theme.kallisto.color.text.static.textSecondary,
    span: {
      marginLeft: $compact ? undefined : "auto",
      alignSelf: $compact ? "center" : undefined,
      "& > svg": {
        "&:hover": {
          color: theme.kallisto.color.text.interactive.textPrimaryDefault,
        },
      },
    },
  })
);

export const FlexibleOfferContainer = styled.div<{ $compact?: boolean }>(
  ({ theme, $compact }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: "4px",
    width: "100%",
    color: theme.kallisto.color.text.static.textSuccess,
    span: {
      marginLeft: $compact ? undefined : "auto",
      alignSelf: $compact ? "center" : undefined,
      "& > svg": {
        cursor: "pointer",
        "&:hover": {
          color: theme.kallisto.color.text.interactive.textPrimaryDefault,
        },
      },
    },
  })
);
